import { ReactNode, useState, useEffect } from "react";

function SideBySide(props: { children: ReactNode[] }) {
  const [isTiny, setIsTiny] = useState(window.innerWidth < 750);

  useEffect(() => {
    const handleResize = () => {
      setIsTiny(window.innerWidth < 750);
    };

    window.addEventListener("resize", handleResize);
    // Cleanup the event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={{ display: "flex", marginBottom: "10px", flexDirection: isTiny ? "column" : "row" }}>
      {props.children}
    </div>
  );
}

export default SideBySide;
